// Столбцы таблицы спецификации (ТЗ 6.2) в одном месте: заголовок и строки берут из него и
// подписи, и ширины, поэтому шапка всегда совпадает со строками при горизонтальной прокрутке.
// Сгенерировано Claude.

/** key — имя столбца, title — подпись, width — ширина в пикселях, sort — как сортировать. */
export const COLUMNS = [
  { key: 'check', title: '', width: 34 },
  { key: 'drag', title: '', width: 24 },
  { key: 'photo', title: 'Фото', width: 60 },
  { key: 'name', title: 'Наименование', width: 220, sort: 'name' },
  { key: 'expand', title: 'Отклики', width: 80, sort: 'offers' },
  { key: 'brand', title: 'Бренд', width: 110, sort: 'brand' },
  { key: 'series', title: 'Серия', width: 100 },
  { key: 'article', title: 'Артикул', width: 100 },
  { key: 'colorMaterial', title: 'Цвет / материал', width: 120 },
  { key: 'dimensions', title: 'Габариты', width: 100 },
  { key: 'room', title: 'Помещение', width: 130, sort: 'room' },
  { key: 'quantity', title: 'Кол-во план', width: 80, sort: 'quantity' },
  { key: 'quantityFact', title: 'Кол-во факт', width: 80, sort: 'quantityFact' },
  { key: 'unit', title: 'Ед.', width: 80 },
  { key: 'delivery', title: 'Срок', width: 120, sort: 'deliveryDays' },
  { key: 'comment', title: 'Комментарий', width: 150 },
  { key: 'plannedPrice', title: 'Плановая цена', width: 130, sort: 'plannedPrice' },
  { key: 'supplierPrice', title: 'Цена поставщика', width: 130, sort: 'supplierPrice' },
  { key: 'discount', title: 'Перс. скидка', width: 120 },
  { key: 'customerDiscount', title: 'Скидка заказчику', width: 130 },
  { key: 'customerPrice', title: 'Цена для заказчика', width: 140, sort: 'customerPrice' },
  { key: 'customerTotal', title: 'Сумма для заказчика', width: 150, sort: 'customerTotal' },
  { key: 'reward', title: 'Вознаграждение', width: 130 },
  { key: 'commission', title: 'Комиссия', width: 110 },
  { key: 'income', title: 'Доход дизайнера', width: 130, sort: 'designerIncome' },
  { key: 'planDeviation', title: 'Отклонение от плана', width: 150, sort: 'planDeviation' },
  { key: 'supplier', title: 'Поставщик', width: 140, sort: 'supplierName' },
  { key: 'rewardReceived', title: 'Вознаграждение получено', width: 130 },
  { key: 'status', title: 'Статус', width: 170, sort: 'status' },
  { key: 'actions', title: '', width: 150 },
];

const BY_KEY = COLUMNS.reduce((acc, column) => ({ ...acc, [column.key]: column }), {});

/** Инлайновый стиль ячейки: ширина столбца задаётся в одном месте (см. COLUMNS). */
export function colStyle(key) {
  const width = `${BY_KEY[key]?.width ?? 100}px`;
  return { width, minWidth: width, maxWidth: width };
}

/** Суммарная ширина таблицы — для контейнера с горизонтальной прокруткой. */
export const TOTAL_WIDTH = COLUMNS.reduce((acc, column) => acc + column.width, 0);
